import cn from 'classnames';

import OPE from 'js/on-page-editing';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Heading from 'components/heading/Heading';

import { IImageWithLink } from 'source/NFR.types';

const ImageWithLink: React.FC<IImageWithLink> = ({
  image,
  onPageEditing,
  title,
  text,
  url,
  shareImageHeight,
  isProminent
}) => (
  <a className="image-with-link" href={url}>
    <div className="image-with-link--image">
      <div
        className={cn('image-with-link--image-inner', {
          '-hover-effect-active': onPageEditing && Object.keys(onPageEditing).length === 0,
          '--absolute-height': shareImageHeight
        })}
      >
        <Image {...imageSizes.imageWithLink} {...image} />
      </div>
    </div>
    {onPageEditing?.url && <div {...OPE(onPageEditing?.url)} />}
    {(title || text || onPageEditing?.title || onPageEditing?.text) && (
      <div
        {...OPE(onPageEditing?.title)}
        className={`image-with-link--description ${isProminent ? 'dark-version' : ''}`}
      >
        {(title || onPageEditing?.title) && <Heading className="image-with-link--title">{title}</Heading>}
        {(text || onPageEditing?.text) && <p className="image-with-link--text">{text}</p>}
      </div>
    )}
  </a>
);

ImageWithLink.displayName = 'ImageWithLink';

export default ImageWithLink;
